import { render, staticRenderFns } from "./LocaleRouterLink.vue?vue&type=template&id=280a68fc"
import script from "./LocaleRouterLink.vue?vue&type=script&lang=js"
export * from "./LocaleRouterLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports